// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"0d3e9cf6","69":"956d5c52","199":"8a6f44c8","523":"dfdf3c3f","532":"f66ffe96","557":"6cb8aa8a","653":"da269179","682":"1395e1cb","849":"aee5bf7a","883":"4b1b6ebd","925":"7e442a70","973":"3e960c23"}[chunkId] + ".chunk.js";
};